import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, DestroyRef, inject } from '@angular/core';
import { RoleActionService, RoleService } from '../../../index';
import { AssignRoleAction, Roles } from '../../../models';
import { concatMap } from 'rxjs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { ToastAlertService } from '@core/index';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'app-assign-action',
  templateUrl: './assign-action.component.html',
  standalone: true,
  imports: [
    ToolbarComponent,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    NgIf,
    MatIconModule,
    MatCardModule,
    MatListModule,
    NgFor,
    MatTooltipModule,
    MatSlideToggleModule,
    MatChipsModule,
  ],
})
export class AssignActionComponent {
  public rolesService = inject(RoleService);
  private serviceAttributions = inject(RoleActionService);
  private alertService = inject(ToastAlertService);
  public currentRole!: Roles;
  public roles!: Roles[];
  public showList: model[] = [];
  private destroyRef = inject(DestroyRef);
  dataSource: any;
  fielInput!: string;

  constructor() {
    this.rolesService
      .getRoles()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((request: any) => {
        if (request.code === 10000) {
          this.roles = request.reply.filter((val: Roles) => {
            return (
              val.name !== 'CLIENTE' &&
              val.name !== 'SYSADMIN' &&
              val.name !== 'CLIENTE-PARQUEO' &&
              val.name !== 'ACCESOS'
            );
          });
          this.dataSource = this.roles;
        }
      });

    this.currentRole = {
      roleid: -1,
      name: '',
      rolecode: '',
      description: '',
      type: '',
      recurrence: -99,
    };
  }

  buscarRoles() {
    if (this.fielInput) {
      this.roles = this.dataSource.filter((role: Roles) => {
        return role.name.toLowerCase().includes(this.fielInput.toLowerCase());
      });
    } else {
      this.roles = this.dataSource;
    }
  }

  setCurrentRole(role: Roles): void {
    this.currentRole = role;
    this.loadAttributions();
  }

  loadAttributions() {
    this.showList = [];

    this.serviceAttributions
      .getRoleAssigned(this.currentRole.roleid)
      .pipe(
        concatMap((request: any) => {
          if (request.code === 10000 || request.code === 40009) {
            for (const item of request.reply) {
              const element: model = {
                action: item,
                state: true,
              };
              this.showList.push(element);
            }
          } else {
            this.alertService.error(request.detail);
          }
          return this.serviceAttributions.getRoleNotAssigned(
            this.currentRole.roleid
          );
        })
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000 || request.code === 40009) {
            for (const item of request.reply) {
              const element: model = {
                action: item,
                state: false,
              };
              if (item.name != 'CLIENTE') {
                this.showList.push(element);
              }
            }
          } else {
            this.alertService.error(request.detail);
          }
        },
      });
  }

  onChipClick(val: model) {
    console.log(val);
    if (val.state) {
      this.serviceAttributions
        .deleteRoleAsssignment(val.action.role_action_id!)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.loadAttributions();
        });
    } else {
      this.serviceAttributions
        .storeRoleAssigment(this.currentRole.roleid, val.action.action_id)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.loadAttributions();
        });
    }
  }
}

interface model {
  action: AssignRoleAction;
  state: boolean;
}
